import { ref } from 'vue';

// 드래그 앤 드롭 상태
const isDragging = ref(false);
const dragCounter = ref(0);
// 신규 업로드된 파일
const uploadedFiles = ref<File[]>([]);
// 서버에서 내려온 기존 파일
const existingFiles = ref<any[]>([]);
// 삭제 체크된 기존 파일 SN
const deleteFileIds = ref<string[]>([]);
// 이미지 URL 캐싱 (ObjectURL 관리용)
const imageUrls = ref<Map<string, string>>(new Map());

export const useAttachmentStore = () => {
  return {
    isDragging,
    dragCounter,
    imageUrls,
    uploadedFiles,
    existingFiles,
    deleteFileIds
  };
};
